import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/learningOutcomes';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';
import { IAddLearningOutcomes, IAddLearningOutcomesForActivity, IAddLearningOutcomesForQuestion, IDeleteLearningOutcomes, IGetLearningOutcomesData, IUpdateLearningOutcomes } from '../../models/action/learningOutcomes';
import { LearningOutcomesService } from '../../api/learning-outcomes-service';
import * as learningoutcomesPageAction from '../actions/learningOutcomes';

const T = Translator.create();
const _logger = Log.create('Survey Saga');
const _learningOutcomesService = new LearningOutcomesService();

function handleErrors(errorList: any) {
    if (errorList) {
        Object.keys(errorList).forEach((key: any) => {
            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
        });
    } else {
        Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
    }
}

function handleSpinnerAndCallback(params: any, callbackData: any) {
    if (params.spinnerId) {
        put(coreActions.setSpinner(params.spinnerId, 'set'));
    }
    if (params.callback) {
        params.callback(callbackData);
    }
}

function logError(error: any) {
    _logger.error(error);
    Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
}

function* addLearningOutComes(params: IAddLearningOutcomes): any {
    try {
        const response: Response = yield _learningOutcomesService.RequestAddLearningOutcomesAsync({ learningOutcomeValue: params.learningOutcomeValue });

        if (response.status !== 200) {
            const errorList = yield response.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        const pageData = yield response.json();

        const newParams = [{ "learningOutcomeId": pageData, "connectedId": params.courseId }]
        const addCourseDependencyResponse: Response = yield _learningOutcomesService.RequestAddCourseDependencyAsync({ connectLearningOutcomes: newParams });

        if (addCourseDependencyResponse.status !== 200) {
            const errorList = yield addCourseDependencyResponse.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        yield addCourseDependencyResponse.json();

        Notification.setNotification("success", T.t("r_add_learning_outcome_success"), 'topRight');
        if (params.callback) {
            params.callback("");
        }

    } catch (error: any) {
        logError(error);
    }
}

function* getLearningOutComesList(params: IGetLearningOutcomesData): any {
    try {
        const response: Response = yield _learningOutcomesService.RequestGetLearningOutcomesAsync(params);

        if (response.status !== 200) {
            const errorList = yield response.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        const pageData = yield response.json();

        yield put(learningoutcomesPageAction.setLearningOutcomes(pageData.results, params.spinnerId ?? '', 'set'));

    } catch (error: any) {
        logError(error);
    }
}


function* deleteLearningOutcome(params: IDeleteLearningOutcomes): any {
    try {
        // İlk işlem: Bağımlılık silme isteği
        const newParams = [{ "learningOutcomeId": params.learningOutcomeId, "connectedId": params.courseId }];
        const deleteCourseDependencyResponse: Response = yield _learningOutcomesService.RequestDeleteCourseDependencyAsync({ connectLearningOutcomes: newParams });

        if (deleteCourseDependencyResponse.status !== 200) {
            const errorList = yield deleteCourseDependencyResponse.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        yield deleteCourseDependencyResponse.json();

        // İkinci işlem: Öğrenim çıktısını silme isteği
        const response: Response = yield _learningOutcomesService.RequestDeleteLearningOutcomesAsync(params);

        if (response.status !== 200) {
            const errorList = yield response.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        const pageData = yield response.json();

        Notification.setNotification("success", pageData, 'topRight');
        if (params.callback) {
            params.callback("");
        }

    } catch (error: any) {
        logError(error);
    }
}

function* updateLearningOutcomes(params: IUpdateLearningOutcomes): any {
    try {
        const response: Response = yield _learningOutcomesService.RequestUpdateCourseAsync(params);

        if (response.status !== 200) {
            const errorList = yield response.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        yield response.json();

        Notification.setNotification("success", T.t("r_update_learning_outcome_success"), 'topRight');

        if (params.callback) {
            params.callback("");
        }

    } catch (error: any) {
        logError(error);
    }
}


function* addLearningOutcomeForActivity(params: IAddLearningOutcomesForActivity): any {
    try {
        const response: Response = yield _learningOutcomesService.RequestAddLearningOutcomesForActAsync({ connectLearningOutcomes: [{ "learningOutcomeId": params.learningOutcomeId, "connectedId": params.activityId }] });

        if (response.status !== 200) {
            const errorList = yield response.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        const pageData = yield response.json();
        
        if (params.callback) {
            params.callback("");
        }

    } catch (error: any) {
        logError(error);
    }
}

function* addLearningOutcomeForQuestion(params: IAddLearningOutcomesForQuestion): any {
    try {
        const response: Response = yield _learningOutcomesService.RequestAddLearningOutcomesForQuestionAsync({ connectLearningOutcomes: [{ "learningOutcomeId": params.learningOutcomeId, "connectedId": params.questionId }] });

        if (response.status !== 200) {
            const errorList = yield response.json();
            handleErrors(errorList);
            handleSpinnerAndCallback(params, null);
            return;
        }

        const pageData = yield response.json();
        
        if (params.callback) {
            params.callback("");
        }

    } catch (error: any) {
        logError(error);
    }
}



export function* watchAddLearningOutcomes() {
    yield takeEvery(constants.actions.ADD_LEARNING_OUTCOMES, addLearningOutComes);
    return null;
}

export function* watchgetLearningOutComesList() {
    yield takeEvery(constants.actions.GET_LEARNING_OUTCOMES_LIST, getLearningOutComesList);
    return null;
}

export function* watchDeleteLearningOutcome() {
    yield takeEvery(constants.actions.DELETE_LEARNING_OUTCOMES, deleteLearningOutcome);
    return null;
}

export function* watchUpdateLearningOutcome() {
    yield takeEvery(constants.actions.UPDATE_LEARNING_OUTCOMES, updateLearningOutcomes);
    return null;
}


export function* watchAddLearningOutcomeForActivity() {
    yield takeEvery(constants.actions.ADD_LEARNING_OUTCOMES_FOR_ACTIVITY, addLearningOutcomeForActivity);
    return null;
}

export function* watchAddLearningOutcomeForQuestion() {
    yield takeEvery(constants.actions.ADD_LEARNING_OUTCOMES_FOR_QUESTION, addLearningOutcomeForQuestion);
    return null;
}

export function* LearningOutcomesSagas() {
    yield all([
        watchAddLearningOutcomes(),
        watchgetLearningOutComesList(),
        watchDeleteLearningOutcome(),
        watchUpdateLearningOutcome(),
        watchAddLearningOutcomeForActivity(),
        watchAddLearningOutcomeForQuestion()
    ]);
}
